<template>
    <button :type="buttonType" :class="['primary-button', {'mode-1': mode == 1}, {'mode-2': mode == 2}]" :style="[{'max-width': buttonWidth}, {'--padding-block': paddingY}, {'--padding-inline': paddingX}]">
        <slot name="content">

        </slot>
    </button>
</template>
<script>
export default {
    props: {
        mode: { // 0, 1, 2
            type: Number,
            default: 0,
        },
        buttonType: {
            type: String,
            default: "button"
        },
        buttonWidth: {
            type: String,
            default: "237px"
        },
        paddingY: {
            type: String,
            default: "13px"
        },
        paddingX: {
            type: String,
            default: "22px"
        }
    }
}
</script>
<style scoped>
.primary-button{
    padding-inline: var(--padding-inline);
    padding-block: var(--padding-block);
    background-color: var(--extra-green);
    border-radius: 0.5em;
    border: 2px solid transparent;
    color: var(--secondary-background-color);
    width: 100%;
    transition: all 0.3s linear;
    text-align: center;
}
.primary-button.mode-1{
    border-color: var(--extra-green);
    background-color: inherit;
    color: var(--extra-green);
}
.primary-button.mode-2{
    border-color: var(--middle-blue);
    background-color: inherit;
    color: var(--middle-blue);
}
@media screen and (max-width: 1720px) {
    .primary-button{
        padding-inline: calc(var(--padding-inline) * 90 / 100);
        padding-block: calc(var(--padding-block) * 90 / 100);
    }
}
@media screen and (max-width: 1560px) {
    .primary-button{
        padding-inline: calc(var(--padding-inline) * 80 / 100);
        padding-block: calc(var(--padding-block) * 80 / 100);
    }
}
</style>